/* YMM picker v6.1 — shared library for hero + modal pickers.
   v6.1 change: placeholder text ("Year", "Make", "Model", "All trims", "All engines")
   is read from the initial DOM (which Liquid renders per locale) and preserved
   through dropdown rebuilds. This is how EN/FR is handled — the picker doesn't
   need to know the language, Liquid does.

   - Loads YMM data from a JSON URL (cached on window.YMM).
   - Reads hide config from #ymm-hide-config script.
   - Hidden makes / models filtered out at dropdown build time. Hiding a make
     cascades to its models (and their trims / engines).
   - Exposes window.YMM.initPicker(config) which both sections call.
*/
(function () {
  if (window.YMM && window.YMM.initPicker) return;
  window.YMM = window.YMM || {};
  var Y = window.YMM;
  Y.KEY = 'ymm.selection.v11';
  Y.VEH = {}; Y.YR = {}; Y.TE = {}; Y.ALIAS = {}; Y.ALLOWED = {};

  function parseHides() {
    var node = document.getElementById('ymm-hide-config');
    var out = { makes: {}, models: {} };
    if (!node) return out;
    try {
      var cfg = JSON.parse(node.textContent || '{}');
      (cfg.hidden_makes_raw || '').split(/[\n,]/).forEach(function (s) {
        var v = String(s || '').trim().toLowerCase();
        if (v) out.makes[v] = 1;
      });
      (cfg.hidden_models_raw || '').split(/[\n,]/).forEach(function (s) {
        var v = String(s || '').trim().toLowerCase();
        if (v) out.models[v] = 1;
      });
    } catch (e) {}
    return out;
  }

  Y.loadData = function (dataUrl) {
    if (Y.dataPromise) return Y.dataPromise;
    Y.dataPromise = fetch(dataUrl).then(function (r) { return r.json(); }).then(function (data) {
      var hides = parseHides();
      var makesByCode = {};
      (data.makes || []).forEach(function (m) { makesByCode[m.code] = m.name; });
      (data.models || []).forEach(function (m) {
        if (hides.makes[m.make]) return;
        if (hides.models[m.code]) return;
        Y.VEH[m.code] = [makesByCode[m.make] || m.make, m.name, m.body || ''];
        Y.YR[m.code] = [m.min_year, m.max_year];
        Y.TE[m.code] = { trims: m.trims || [], engines: m.engines || [] };
        Y.ALLOWED[m.code] = 1;
      });
      Y.ALIAS = data.alias || {};
      return data;
    }).catch(function () { return null; });
    return Y.dataPromise;
  };

  function canon(v) { v = String(v == null ? '' : v).trim().toLowerCase(); return Y.ALIAS[v] || v; }
  function nice(k) { k = canon(k); var v = Y.VEH[k]; return v ? [v[0], v[1], v[2]].filter(Boolean).join(' ') : k; }
  function modelLabel(k) { var v = Y.VEH[k]; return v ? (v[1] + (v[2] ? ' (' + v[2] + ')' : '')) : k; }
  function allCodesForYear(y) { y = parseInt(y, 10); if (!y) return []; return Object.keys(Y.VEH).filter(function (k) { var r = Y.YR[k]; return r && y >= r[0] && y <= r[1]; }); }
  function allYears() { var s = {}; Object.keys(Y.VEH).forEach(function (k) { var r = Y.YR[k]; if (!r) return; for (var y = r[0]; y <= r[1]; y++) s[y] = 1; }); return Object.keys(s).map(Number).sort(function (a, b) { return b - a; }); }
  function makesForYear(y) { var seen = {}; allCodesForYear(y).forEach(function (k) { seen[Y.VEH[k][0]] = 1; }); return Object.keys(seen).sort(); }
  function modelsForYearMake(y, m) { return allCodesForYear(y).filter(function (k) { return Y.VEH[k][0] === m; }); }
  function opt(s, v, t) { var o = document.createElement('option'); o.value = v; o.textContent = t || v; s.appendChild(o); }
  function readStored() { try { var s = JSON.parse(localStorage.getItem(Y.KEY) || '{}') || {}; s.model = canon(s.model); if (s.model && !Y.ALLOWED[s.model]) { localStorage.removeItem(Y.KEY); return {}; } if (s.model && !s.label) s.label = nice(s.model); return s; } catch (e) { return {}; } }
  function has(s) { return !!(s && (s.year || s.make || s.model || s.trim || s.engine)); }

  Y.canon = canon; Y.nice = nice; Y.has = has; Y.readStored = readStored;

  /* config = {
       dataUrl: string,
       els:    { year, make, model, trim, engine, apply, reset },
       onApply: function(sel),
       onReset: function(),
       onInit:  function(saved)
     }
  */
  Y.initPicker = function (config) {
    var els = config.els;

    /* Read the initial placeholder text from each select. Liquid renders this
       per locale (EN or FR), and we preserve it through every rebuild. */
    function readPh(s, fb) {
      var opt = s && s.querySelector('option[value=""]');
      return (opt && opt.textContent && opt.textContent.trim()) || fb;
    }
    var L = {
      year:   readPh(els.year,   'Year'),
      make:   readPh(els.make,   'Make'),
      model:  readPh(els.model,  'Model'),
      trim:   readPh(els.trim,   'All trims'),
      engine: readPh(els.engine, 'All engines')
    };

    function clearOpts(s, key) {
      s.innerHTML = '<option value="" selected disabled hidden>' + L[key] + '</option>';
    }
    function clearTE() {
      els.trim.innerHTML = '<option value="" selected>' + L.trim + '</option>';
      els.engine.innerHTML = '<option value="" selected>' + L.engine + '</option>';
      els.trim.disabled = true;
      els.engine.disabled = true;
    }
    function fillYears() { clearOpts(els.year, 'year'); allYears().forEach(function (y) { opt(els.year, String(y), String(y)); }); }
    function fillMakes() { var y = els.year.value; els.make.disabled = !y; clearOpts(els.make, 'make'); clearOpts(els.model, 'model'); els.model.disabled = true; clearTE(); if (!y) return; makesForYear(y).forEach(function (m) { opt(els.make, m, m); }); }
    function fillModels() { var y = els.year.value, m = els.make.value; els.model.disabled = !(y && m); clearOpts(els.model, 'model'); clearTE(); if (!(y && m)) return; modelsForYearMake(y, m).forEach(function (code) { opt(els.model, code, modelLabel(code)); }); }
    function fillTE() { var code = canon(els.model.value); clearTE(); if (!code || !Y.TE[code]) return; var t = Y.TE[code]; if (t.trims && t.trims.length) { els.trim.disabled = false; t.trims.forEach(function (v) { opt(els.trim, v, v); }); } if (t.engines && t.engines.length) { els.engine.disabled = false; t.engines.forEach(function (v) { opt(els.engine, v, v); }); } }

        function syncApply() {
      if (!els.apply) return;
      var ready = !!canon(els.model.value);
      els.apply.disabled = !ready;
      els.apply.setAttribute('aria-disabled', ready ? 'false' : 'true');
    }
    function doApply() {
      var code = canon(els.model.value);
      if (!code) { syncApply(); return; }
      if (!Y.ALLOWED[code]) { doReset(); return; }
      var v = Y.VEH[code] || ['', '', ''];
      var sel = {
        year: els.year.value || '',
        make: els.make.value || (code ? v[0] : ''),
        model: code || '',
        model_name: code ? v[1] : '',
        body: code ? v[2] : '',
        trim: els.trim.value || '',
        engine: els.engine.value || '',
        label: code ? nice(code) : ''
      };
      try { localStorage.setItem(Y.KEY, JSON.stringify(sel)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('ymm:applied', { detail: sel }));
      window.dispatchEvent(new CustomEvent('ymm:changed', { detail: sel }));
      if (config.onApply) config.onApply(sel);
    }

    function doReset() {
      try { localStorage.removeItem(Y.KEY); } catch (e) {}
      els.year.value = '';
      fillMakes();
      document.dispatchEvent(new CustomEvent('ymm:applied', { detail: {} }));
      window.dispatchEvent(new CustomEvent('ymm:changed', { detail: {} }));
      window.dispatchEvent(new CustomEvent('ymm:reset', { detail: {} }));
      if (config.onReset) config.onReset();
    }

    function restore() {
      var s = readStored();
      if (!has(s)) { fillMakes(); return s; }
      if (s.year)   els.year.value = String(s.year);
      fillMakes();
      if (s.make)   els.make.value = s.make;
      fillModels();
      if (s.model)  els.model.value = s.model;
      fillTE();
      if (s.trim)   els.trim.value = s.trim;
      if (s.engine) els.engine.value = s.engine;
      return s;
    }

    Y.loadData(config.dataUrl).then(function (data) {
      if (!data) return;
      fillYears();
      els.make.disabled = true;
      els.model.disabled = true;
      clearTE();
      var saved = restore();
      els.year.addEventListener('change', fillMakes);
      els.make.addEventListener('change', fillModels);
      els.model.addEventListener('change', fillTE);
      els.year.addEventListener('change', syncApply);
      els.make.addEventListener('change', syncApply);
      els.model.addEventListener('change', syncApply);
      if (els.apply) els.apply.addEventListener('click', doApply);
      if (els.reset) els.reset.addEventListener('click', doReset);
      syncApply();
      if (config.onInit) config.onInit(saved);
    });
  };
})();
